<template>
  <div class="hello">
    {{ msg }}
    <div class="andrymi">
      Þessi síða sýnir hvað eru margar vikur, dagar, klukkustundir, mínútur eða sekúndur síðan þú fæddist
    </div>
    <div>
      Hvenær fæddist þú?
    </div>
    <datetime class="andrymi" v-model="faeddistCal"></datetime>
    <div class="andrymi">
      <p>Þú fæddist {{ faedingardagur }}</p>
    </div>
    <div class="andrymi">
      Það eru {{ sekundur }} sekúndur síðan þú fæddist.
    </div>
    <div class="andrymi">
      Það eru {{ minutur }} míntútur síðan þú fæddist.
    </div>
    <div class="andrymi">
      Það eru {{ klukkustundir }} klukkustundir síðan þú fæddist.
    </div>
    <div class="andrymi">
      Það eru {{ dagar }} dagar síðan þú fæddist.
    </div>
    <div class="andrymi">
      Það eru {{ vikur }} vikur síðan þú fæddist.
    </div>
  </div>
</template>

<script>
import moment from 'moment'

function iSekundum (nuna, dagsettning) {
  dagsettning = (dagsettning) ? new Date(dagsettning) : nuna
  return Math.round((nuna - dagsettning) / 1000)
}

const data = {
  nuna: new Date(),
  faeddistCal: '',
  checked: false,
  ticker: false
}

export default {
  name: 'HelloWorld',
  data: () => data,
  computed: {
    faeddist: function () {
      return (this.faeddistCal) ? new Date(this.faeddistCal) : this.nuna
    },
    faedingardagur: function () {
      const dagsettning = (this.faeddist) ? new Date(this.faeddist) : new Date()
      return moment(dagsettning).locale('is').fromNow()
    },
    sekundur: function () {
      return iSekundum(this.nuna, this.faeddist).toLocaleString()
    },
    minutur: function () {
      return Math.round(iSekundum(this.nuna, this.faeddist) / 60).toLocaleString()
    },
    klukkustundir: function () {
      return Math.round(iSekundum(this.nuna, this.faeddist) / 60 / 60).toLocaleString()
    },
    dagar: function () {
      return Math.round(iSekundum(this.nuna, this.faeddist) / 60 / 60 / 24).toLocaleString()
    },
    vikur: function () {
      return Math.round(iSekundum(this.nuna, this.faeddist) / 60 / 60 / 24 / 7).toLocaleString()
    }
  },
  props: {
    msg: String
  },
  created: function () {
    var self = this
    this.ticker = setInterval(function () {
      self.nuna = Date.now()
    }, 1000)
  },
  beforeDestroy: function () {
    clearTimeout(this.ticker)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.andrymi {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
